//import MpTextField from "./components/input/mp-text-field.vue";
/**
 * You can register global components here and use them as a plugin in your main Vue instance
 */

const GlobalComponents = {
    /*install(Vue) {
        Vue.component("mp-text-field", MpTextField);
    }*/
};

export default GlobalComponents;
